import { motion } from "framer-motion";
import { EASE } from "@/components/Reveal";

export default function PageHeader({ eyebrow, title, accent, copy, testid }) {
  return (
    <section data-testid={testid} className="relative overflow-hidden bg-obsidian px-5 pb-14 pt-32 sm:px-8 lg:pt-40">
      <div
        className="pointer-events-none absolute inset-0"
        style={{ background: "radial-gradient(ellipse 55% 45% at 50% 0%, rgba(224,90,43,0.18) 0%, rgba(11,12,16,0) 70%)" }}
      />
      <div className="relative mx-auto max-w-7xl">
        <motion.p
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: EASE }}
          className="font-mono text-xs uppercase tracking-[0.35em] text-saffron"
          data-testid={`${testid}-eyebrow`}
        >
          {eyebrow}
        </motion.p>
        <motion.h1
          initial={{ opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1, ease: EASE }}
          className="mt-5 font-display text-4xl font-semibold leading-[1.06] tracking-tight text-cream sm:text-5xl lg:text-6xl"
          data-testid={`${testid}-title`}
        >
          {title} {accent && <span className="font-serif italic font-medium text-saffron">{accent}</span>}
        </motion.h1>
        {copy && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.22, ease: EASE }}
            className="mt-6 max-w-xl text-base leading-relaxed text-slate-400 sm:text-lg"
          >
            {copy}
          </motion.p>
        )}
      </div>
    </section>
  );
}
